import { render, staticRenderFns } from "./HeaderBox.vue?vue&type=template&id=f7272f0e"
import script from "./HeaderBox.vue?vue&type=script&lang=ts"
export * from "./HeaderBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports